if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.closest('.product-media-modal__dialog')?.classList.add('active');
        // safely hide other modal close btns to prevent overlapping and confusion for assistive technologies
        const modalCloseBtns = this.querySelectorAll('.product-media-modal__toggle');
        if(modalCloseBtns.length > 1) {
          modalCloseBtns.forEach((btn, index) => {if(index !== 0) btn.classList.add('hidden')});
        }

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
          // scroll into center of the image
          activeMedia.scrollIntoView({block: 'center', inline: 'center'});
      }
    }
  );
}
